export enum NotificationType {
  LOGIN_SUCCESS = 'login-success',
  LOGOUT = 'logout',
  PASSWORD_CHANGE_SUCCESS = 'password-change-success',
  INCORRECT_PASSWORD = 'incorrect-password',
  PROFILE_UPDATE_SUCCESS = 'profile-update-success',
  APP_UPDATE_INSTALLED = 'app-update-installed',
  PRINT_SUCCESS = 'print-success',
  PRINT_FAILED = 'print-failed',
}
